(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items=document.querySelectorAll('.av-faq details');
  [].forEach.call(items,function(d){
    if(d.getAttribute('data-av-init'))return;
    d.setAttribute('data-av-init','1');
    var s=d.querySelector('summary'),c=d.querySelector('.av-faq__a');
    if(!s||!c)return;
    var anim=null;
    s.addEventListener('click',function(e){
      e.preventDefault();
      var opening=!d.open||(anim&&anim.avClosing);
      if(reduce||!c.animate){d.open=opening;return;}
      var cs=window.getComputedStyle(c);
      var curH=d.open?c.getBoundingClientRect().height:0;
      var curP=d.open?parseFloat(cs.paddingBottom)||0:0;
      var curO=d.open?parseFloat(cs.opacity):0;
      if(anim){anim.onfinish=null;anim.oncancel=null;anim.cancel();anim=null;}
      c.style.overflow='hidden';c.style.boxSizing='border-box';
      var toH,toP,toO;
      if(opening){
        d.open=true;
        c.style.height='';c.style.paddingBottom='';
        toH=c.getBoundingClientRect().height;toP=parseFloat(window.getComputedStyle(c).paddingBottom)||0;toO=1;
      }else{toH=0;toP=0;toO=0;}
      var a=c.animate([
        {height:curH+'px',paddingBottom:curP+'px',opacity:curO},
        {height:toH+'px',paddingBottom:toP+'px',opacity:toO}
      ],{duration:300,easing:'cubic-bezier(.2,.7,.2,1)'});
      a.avClosing=!opening;
      anim=a;
      a.onfinish=function(){
        if(!opening)d.open=false;
        c.style.overflow='';c.style.boxSizing='';anim=null;
      };
    });
  });
})();
